module.exports = __webpack_public_path__ + "img/chat_white.8bf27be8.svg";